export default __webpack_public_path__ + "static/media/alacrity.acf055b6.mpeg";